import { MainContentArea, ContentHeader } from "melco-ui";
import { LocaleStringsList } from "../../components/localestrings/LocaleStringsList";
import { useTranslation } from "react-i18next";

// To Do: Add BreadCrum
// Add Translation
export const LocaleStrings: React.FC = () => {
  const { t } = useTranslation();
  //const breadcrumb = useBreadcrumb("orders");

  

  return (
    <MainContentArea
      header={
        <ContentHeader 
          title={t("main_menu.local_strings")}
          
        />
        
      }
    >
    
       <LocaleStringsList /> 
    </MainContentArea>
  );
};
